module.exports = __webpack_public_path__ + "static/media/addAttachmentHover.d1ff7213.png";